<template>
    <div>
        <div class="writing-section" ref="writingSection">
            <button v-if="isRecording" @click="cancelRecording" title="Cancelar grabación" class="cancel-button">
                <span class="material-symbols-outlined">cancel</span>
            </button>
            <div v-if="isRecording" class="audio-waveform">
                <span><strong>Grabando...</strong></span>
            </div>
            <textarea v-else ref="textarea" v-model="message" class="text-area" placeholder="Escribe tu consulta..."
                @keydown.enter.prevent="sendMessageOnEnter"></textarea>
            <input type="file" ref="fileInput" style="display: none;" @change="handleFileUpload"
                accept=".jpg,.jpeg,.png,.webp,.pdf" multiple>
            <button v-if="filelist.length > 0" class="send-button file-button" @click="showFileList = !showFileList"
                title="Ver archivos">
                <span class="material-symbols-outlined">folder_eye</span>
                <span class="file-count">{{ filelist.length }}</span>
            </button>
            <button v-if="!isRecording" @click="openFileExplorer"
                title="Abrir explorador de archivos (Actualmente no disponible)" class="send-button">
                <span class="material-symbols-outlined"> attach_file </span>
            </button>
            <button v-if="message || filelist.length > 0" @click="sendMessage" title="Enviar mensaje"
                class="send-button" :disabled="bloqueado">
                <span class="material-symbols-outlined">send</span>
            </button>
            <button v-else @click="toggleRecording" :title="isRecording ? 'Enviar grabación' : 'Grabar mensaje'"
                :class="{ 'recording-button': isRecording, 'record-button': !isRecording }" :disabled="bloqueado">
                <span class="material-symbols-outlined">{{ isRecording ? 'send' : 'mic' }}</span>
            </button>
        </div>
        <PopupArchivos @deleteItem="deleteItem" @hide="showFileList = !showFileList" :show="showFileList"
            :fileList="filelist"></PopupArchivos>
    </div>
</template>

<script>
import PopupArchivos from './PopupArchivos.vue';
export default {
    name: 'AreaMensaje',
    components: {
        PopupArchivos
    },
    props: {
        bloqueado: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            message: '',
            tipoMensaje: 'texto',
            isRecording: false,
            mediaRecorder: null,
            audioChunks: [],
            filelist: [],
            showFileList: false
        };
    },
    methods: {
        deleteItem(index) {
            this.filelist.splice(index, 1);
        },
        openFileExplorer() {
            this.$refs.fileInput.click();
        },
        handleFileUpload(event) {
            const files = event.target.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const url = URL.createObjectURL(file);
                const data = {
                    archivo: file,
                    extencion: file.name.split('.').pop(),
                    tipo: file.type,
                    nombre: file.name,
                    url: url
                };
                this.filelist.push(data);
                this.tipoMensaje = 'archivo';
            }
        },
        sendMessageOnEnter() {
            if (this.message.trim() !== '') {
                this.sendMessage();
            }
        },
        sendMessage() {
            let mensajeTemp;
            if (this.filelist.length > 0) {
                this.tipoMensaje = "archivos"
                this.filelist.sort((a, b) => a.extencion.localeCompare(b.extencion));
                const contenido = {
                    archivos: this.filelist,
                    mensaje: this.message
                }
                mensajeTemp = { data: contenido, tipo: this.tipoMensaje };
            }
            else {
                this.tipoMensaje = "texto"
                mensajeTemp = { data: this.message, tipo: this.tipoMensaje };
            }
            this.filelist = []
            this.message = '';
            this.$emit('sendMessage', mensajeTemp);
        },
        toggleRecording() {
            if (this.isRecording) {
                this.stopRecording();
            } else {
                this.startRecording();
            }
        },
        startRecording() {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({ audio: true })
                    .then(stream => {
                        this.isRecording = true;
                        this.mediaRecorder = new MediaRecorder(stream);
                        this.mediaRecorder.start();

                        this.mediaRecorder.addEventListener('dataavailable', event => {
                            this.audioChunks.push(event.data);
                        });
                    })
                    .catch(error => {
                        console.error('Error accessing microphone:', error);
                    });
            } else {
                console.error('getUserMedia not supported on your browser!');
            }
        },
        stopRecording() {
            if (this.mediaRecorder && this.isRecording) {
                this.mediaRecorder.stop();
                this.mediaRecorder.addEventListener('stop', () => {
                    const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
                    const audioUrl = URL.createObjectURL(audioBlob);
                    this.sendAudioMessage(audioUrl);
                    this.isRecording = false;
                    this.audioChunks = [];
                });
            }
        },
        cancelRecording() {
            this.isRecording = false;
            this.audioChunks = [];
            if (this.mediaRecorder) {
                this.mediaRecorder.stop();
            }
        },
        sendAudioMessage(audioUrl) {
            const mensajeTemp = { data: audioUrl, tipo: 'audio' };
            this.$emit('sendMessage', mensajeTemp);
        }
    }
};
</script>


<style scoped>
.file-button {
    position: relative;
}

.file-count {
    position: absolute;
    top: 2px;
    right: 2px;
    background-color: #fd4973;
    color: white;
    border-radius: 50%;
    padding: 2px 6px;
    font-size: 0.8rem;
    line-height: 1;
}

.writing-section {
    display: flex;
    align-items: center;
    padding: 10px;
    background-color: white;
    border: none;
    padding: 0px;
}

.text-area {
    flex: 1;
    background-color: #ffffff;
    color: #000000;
    border: none;
    border-radius: 15px;
    padding: 10px;
    resize: none;
    outline: none;
    font-size: 1rem;
    margin-right: 10px;
    box-shadow: none
}

.send-button,
.record-button {
    font-size: 1.5rem;
    padding: 0px;
    border-radius: 15px;
    background-color: white;
    border: none;
    color: black;
    margin-left: 4px;
    transition: background-color 0.3s, border-color 0.3s;
}

.send-button:hover,
.record-button:hover {
    background-color: #2b8b4b;
    border-color: #2b8b4b;
    color: #FEFDF8;
    transition: background-color 0.3s, border-color 0.3s;
}

.recording-button {
    font-size: 1.5rem;
    padding: 10px;
    border-radius: 15px;
    background-color: #2b8b4b;
    border: 2px solid #2b8b4b;
    color: white;
    margin-left: 10px;
    transition: background-color 0.3s, border-color 0.3s;
}

.recording-button:hover {
    background-color: #095636;
    border-color: #095636;
    color: #FEFDF8;
    transition: background-color 0.3s, border-color 0.3s;
}

.send-button:active,
.record-button:active {
    background-color: #00B0A8;
    border-color: #00B0A8;
}

.send-button:disabled,
.record-button:disabled {
    background-color: #212325;
    border-color: #3e4246;
    color: #B9B3AD;
}

.cancel-button {
    font-size: 1.5rem;
    padding: 10px;
    border-radius: 15px;
    background-color: #fd4973;
    border: 2px solid #2b8b4b;
    color: white;
    margin-right: 10px;
    transition: background-color 0.3s, border-color 0.3s;
}

.cancel-button:hover {
    background-color: #e61a42;
    border-color: #e61a42;
    transition: background-color 0.3s, border-color 0.3s;
}

.audio-waveform {
    flex: 1;
    color: #504741;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f5f3;
    border: 1px solid transparent;
    border-radius: 15px;
    padding: 10px;
}

@media (max-width: 100%) {
    .writing-section {
        flex-direction: column;
        align-items: stretch;
    }

    .send-button,
    .record-button {
        margin-left: 0;
        margin-top: 10px;
    }

    .cancel-button {
        margin-right: 0;
        margin-top: 10px;
    }
}
</style>